import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints, ID, Url } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { CUSTOM_RELATIONS_QUERY_KEY } from './useFetchAnnotationCustomRelations';

export const usePatchCustomRelationAnnotations = () => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      relationId,
      annotations,
    }: {
      relationId: ID;
      annotations: Url[];
    }) => api.request(endpoints.relations.patch(relationId, { annotations })),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CUSTOM_RELATIONS_QUERY_KEY],
      });
    },

    onError: () => {
      notify.error({
        title: intl.formatMessage({
          id: 'features.customRelations.errors.updateRelation',
        }),
      });
    },
  });
};
